import { FC } from 'react';
import styled from 'styled-components';
import { fontFamilies } from '~/theme/typography';

const GLOW_IN_THE_DARK_TAG = 'glow in the dark';

export const hasGlowInTheDarkTag = (
  tags: string[] | null | undefined,
): boolean =>
  tags?.some(
    (tag) =>
      typeof tag === 'string' &&
      tag.trim().toLowerCase() === GLOW_IN_THE_DARK_TAG,
  ) ?? false;

interface GlowInTheDarkBadgeProps {
  className?: string;
  compact?: boolean;
}

export const GlowInTheDarkBadge: FC<GlowInTheDarkBadgeProps> = ({
  className,
  compact,
}) => (
  <Badge className={className} $compact={compact}>
    GLOW IN THE DARK
  </Badge>
);

const Badge = styled.span<{ $compact?: boolean }>`
  display: inline-block;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.glowGreen};
  background: ${({ theme }) => theme.colors.glowGreen};
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.glowGreen};

  color: ${({ theme }) => theme.colors.colorMain};
  text-align: center;
  font-family: ${fontFamilies.CircularStd};
  font-size: 12px;
  font-weight: 450;
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  @media ${({ theme }) => theme.breakpoints.sm} {
    box-shadow: 0 0 4px 0 ${({ theme }) => theme.colors.glowGreen};
    font-size: 8px;
  }

  ${({ $compact, theme }) =>
    $compact &&
    `
      box-shadow: 0 0 4px 0 ${theme.colors.glowGreen};
      font-size: 6px;
    `}
`;
